<template>
<div class="login_wraps">
    <div class="login_bg">
    <div class="form_Login">
        <div class="mobile_phone_wrap"></div>
        <div class="text_site">
            <!-- <span class="sp1">Power</span>
            <span class="sp2">Detailing</span> -->
             <span class="sp_b">LADE</span>
             <img :src="get_header.images[0].url" alt="">
        </div>
         <div class="fileds phone_sms">
                 <vs-input v-model="smscode" type="number" placeholder="Sms Code" />
        <!-- <template v-if="valid_sms">
                      <span class="successMSG">The phone number is correct</span>
        </template>
        <template v-if="!valid_sms && smscode !== ''">
          <span class="errorMSG"> Phone number is incorrect</span>
        </template> -->
        </div>
        <div class="button_wrap">
            <vs-button @click.native="submit_verify()" dark :loading="loading_verify"  :disabled="smscode ==''">
        <span>Verify Mobile</span>
      </vs-button>
        </div>
    </div>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "LoginApp",
  data(){
    return{
        valid_sms:false,
         smscode:'',
          opt:{
            disabled:false,
            showDialCodeInList:true,
            showDialCodeInSelection:false,
            showFlags:true,
            showSearchBox:false,
            tabindex:0,
            width:"390px"
          },
          loading_verify:false,
        // inp_opt:{
        //     placeholder: "رقم الموبايل"
        // },
    }
  },
  computed:{
    ...mapGetters({
        loginStatus:'auth/loginStatus',
         authenticated:'auth/authenticated',
        user:'auth/user',
         get_header:'get_header',
    })
  },
  methods:{
        submit_verify(){
            // console.log(this.authenticated && this.user.setted_up==false);
            // if(this.authenticated && this.user.setted_up==false){
            //         this.$router.push({path: '/complete-account'});
            //     }
            this.loading_verify = true;
            let mysms_code = this.smscode;
            let mobile_reg = localStorage.getItem('mobilereg');
            let mobile_sms = {
                'phone': mobile_reg,
                'code':mysms_code,
            }
            console.log(mobile_sms);
            this.mobileverify(mobile_sms).then(()=>{
                this.loading_verify = false;
                if(this.loginStatus.data.success ==false){
                      this.openNotification('bottom-right', 'danger' , 'Error occurred' , 'The code is incorrect');
                }else{
                     this.openNotification('bottom-right', 'success' , 'Login succeeded' , 'Welcome back, you are logged in .');
                }
                if(this.user.name == '' || this.user.city=='' || this.user.city=='' || this.user.city=='' || this.user.email==''){
                    this.$router.push({path: '/complete-account'});
                }else{
                    this.$router.push({path: '/booking'});
                }
            })
        },


                // Notifucation
      openNotification(position = null, color , title , text) {
      this.$vs.notification({
        color,
        position,
        title: title,
        text: text,
      });
    },
    ...mapActions({
        mobileverify :'auth/mobile_verify'
    })
  },
  mounted(){}
};
</script>
<style lang="scss" scoped>
.login_wraps{
    padding-top: 80px;
    padding-bottom: 80px;
    .form_Login{
         width: 370px;
        height: 340px;
         margin-left: auto;
        margin-right: auto;
    background-color: #f6f6f6;
    position: relative;
    }
    .mobile_phone_wrap{
        overflow: hidden;
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 0;
    &::before{
        content: '';
        background-image: url(https://i.pinimg.com/736x/d9/76/8f/d9768f052b88b893dcb3a35224867852.jpg);
        position: absolute;
        left: 0;
         top: -50px;
        width: 100%;
        height: 90%;
        background-size: cover;
        -webkit-clip-path: ellipse(69% 46% at 48% 46%); 
        clip-path: ellipse(69% 46% at 48% 46%);
    }
    }
    .text_site{
      padding-bottom: 30px;
         .sp_b{
    position: absolute;
    font-size: 14px;
    transform: rotate(332deg);
    left: 20%;
    top: 40px;
    font-weight: 500;
    color: #fff;
     font-family: "Oswald", sans-serif;
  }
      img{
        width: 200px;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    top: 10px;
      }
    }
    .phone_sms{
    padding-top: 120px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    }
    
    .vue-tel-input {
    border-radius: 3px;
    display: flex;
    border: 1px solid #bbb;
    text-align: left;
    position: relative;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
    background-color: white;
    border-radius: 30px;
    }
    .successMSG , .errorMSG{
 position: absolute;
    left: 50px;
    right: 0;
    color: white;
    font-size: 15px;
    padding-top: 10px;
    }
    .successMSG{
          color: rgb(23, 201, 100);
    }
    .errorMSG{
        color: rgb(242, 19, 93);
    }
    .button_wrap{
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    }
    .sp1{
    position: absolute;
    top: 30px;
    left: 0;
    font-size: 20px;
    z-index: 9;
    color: rgb(193, 193, 193);
    right: 0;
    margin-left: auto;
    margin-right: 180px;
    text-align: center;
    font-weight: 500;
    }
    .sp2{
    position: absolute;
    top: 55px;
    margin-top: 0px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: #e9c964;
    font-weight: 900;
    text-transform: uppercase;
    font-size: 28px;
    letter-spacing: 4px;
    }
}

</style>